import { useQuery } from '@tanstack/react-query';

import { getTeamEvents } from '../apis';
import { teamKeys } from './teamKeys';

export const useTeamEvents = (query: { from: string; to: string }) =>
  useQuery({
    queryKey: teamKeys.eventsList(query),
    queryFn: () => getTeamEvents(query),
  });
